import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FhInputConfigModel } from '@fh-client-interaction-frontends/input-config';
import { LabelConfigModel } from '@fh-client-interaction-frontends/fh-label';

@Component({
  selector: 'ui-fh-input-switch',
  templateUrl: './fh-input-switch.component.html',
  styleUrls: ['./fh-input-switch.component.scss']
})
export class FhInputSwitchComponent implements OnInit {
  @Input() inputConfig: FhInputConfigModel = new FhInputConfigModel();
  @Input() labelConfigs: LabelConfigModel = new LabelConfigModel();
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() defaultValue: any;
  @Input() icon: string = '';
  value: any;

  ngOnInit() {
    if (this.defaultValue != undefined) {
      this.value = this.defaultValue;
    }
  }

  valueChanged() {
    this.valueChange.emit(this.value);
  }

  getLabelConfigs() {
    this.labelConfigs = {
      class: this.inputConfig?.labelClass ? this.inputConfig?.labelClass + ' label-padding' : 'label-padding',
      label: this.inputConfig?.label
    } as LabelConfigModel;
    return this.labelConfigs;
  }
}
